import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import AppHeader from "@/components/AppHeader";
import { ReturnsProvider } from "@/contexts/ReturnsContext";
import InspectionPage from "@/pages/InspectionPage";
import OwnerReviewPage from "@/pages/OwnerReviewPage";
import ReturnsPage from "@/pages/ReturnsPage";
import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <ReturnsProvider>
        <div className="App">
          <AppHeader />
          <Routes>
            <Route path="/" element={<ReturnsPage />} />
            <Route path="/inspect/:orderId" element={<InspectionPage />} />
            <Route path="/owner" element={<OwnerReviewPage />} />
            <Route path="*" element={<ReturnsPage />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </ReturnsProvider>
    </BrowserRouter>
  );
}